module.exports = __webpack_public_path__ + "static/media/google-icon.103c593e.png";